export default __webpack_public_path__ + "static/Trevor-ecc4b78b54737202571bf25cabf536fd.png";